import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FirestoreService } from './firestore.service';
import { shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

export type ProviderType = 'fornor' | 'koopman' | 'jja' | 'item';
export interface ImportResponse {
  new_products: number;
  order_lines: number;
  purchase_order_id: string;
}
@Injectable({
  providedIn: 'root',
})
export class OrderService {
  firestore = inject(FirestoreService);
  public orders$ = this.firestore.listDocuments('orders').pipe(shareReplay(1));
  constructor(private functions: Functions) {}

  async importOrder(provider_id: ProviderType, file: File) {
    const base64 = await this.readFileAsBase64(file);
    const callable = httpsCallable<
      {
        provider_id: string;
        fileBase64: string;
        fileName: string;
        isProd: boolean;
      },
      ImportResponse
    >(this.functions, 'import_order');
    return callable({
      isProd: environment.production,
      provider_id,
      fileBase64: base64,
      fileName: file.name,
    });
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve((reader.result as string).split(',')[1]); // get only base64 part
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
}
